import { h } from 'preact';
import { ProductPolicy } from 'utils/helpers';
import useDiscount from '../product-discounts/product-discount';

const ProductPolicyNotes = ({
  styleNumber,
  currentProduct,
  currentVariant,
  ...props
}) => {
  const inlineDiscount = useDiscount(
    currentProduct.id,
    currentVariant?.price?.amount ||
      currentProduct?.priceRange.minVariantPrice.amount,
    currentProduct.collectionsId,
  );

  const policyData = ProductPolicy(
    currentProduct,
    currentVariant,
    inlineDiscount,
  );
  if (!policyData.enabled) {
    return false;
  }
  const { policyPopup, currentVariantId, policynotes } = policyData;

  const spanContent = policynotes.match(/<span>.*?<\/span>/g)[0];
  const cleanedStr = policynotes.replace(spanContent, '');

  return (
    <div {...props}>
      <div
        className="product-policy-notes"
        dangerouslySetInnerHTML={{
          __html: cleanedStr,
        }}
      ></div>
      <span
        /* eslint-disable no-undef */
        onClick={() =>
          brOpenPolicyPopup(
            currentVariantId,
            'none',
            'none',
            policyPopup,
            'none',
          )
        }
        /* eslint-enable no-undef */
        className="product-policy-cta"
        dangerouslySetInnerHTML={{
          __html: spanContent,
        }}
      ></span>
    </div>
  );
};

export default ProductPolicyNotes;
